// extracted by css-extract-rspack-plugin
export default {"stayDurationContainer":"stayDuration-module__stayDurationContainer"};